import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { TimeOccurrenceEngine } from '../engines/time/time_engine';
import { TimeOccurrenceServant } from '../servants/time/time_occurrence_servant';
import { IValidation } from './contracts';
import { PhxCalendarConfiguration } from '../config/calendar_configuration';

angular
  .module('ui-ng-calendar')
  .factory(
    'timeEndValidatorFactory',
    function (
      ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
      ngTimeOccurrenceEngine: TimeOccurrenceEngine,
      ngTimeOccurrenceServant: TimeOccurrenceServant,
      ngPhxCalendarConfiguration: PhxCalendarConfiguration,
      timeLowerBoundCorrector: any
    ) {
      return (store: ITimeOccurrenceDatatype[]): IValidation => {
        return {
          isValid: true,
          corrector: timeLowerBoundCorrector
        };
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/validation/time_end_validator.ts